export default {
  data: {
    language: "",
    theme: "",
    showNotice: true,
  },
  views: {},
};
